// extracted by mini-css-extract-plugin
module.exports = {"textarea":"style_textarea__3vcs-"};